import { ClickAwayListener, FormControl, FormControlLabel, Paper, Popper, Radio, RadioGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SET_LANGUAGE } from 'store/actions';

const LanguageSelector = (props) => {
    const { open, setOpen, anchorRef, language } = props;
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const theme = useTheme();
    const [selectedLanguage, setLanguage] = useState(language);

    const handleLanguageChange = (value) => {
        setLanguage(value);
        dispatch({ type: SET_LANGUAGE, language: value });
        i18n.changeLanguage(value);
        setOpen(false);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    return (
        <Popper placement="bottom-end" open={open} anchorEl={anchorRef.current} sx={{ zIndex: 1600, mt: 0.75 }}>
            <ClickAwayListener onClickAway={handleClose}>
                <Paper elevation={5} sx={{ minWidth: 156, border: '1px solid #d6e0ea', borderRadius: 1, overflow: 'hidden' }}>
                    <FormControl sx={{ width: '100%', p: 0.5 }}>
                        <RadioGroup
                            aria-label="language"
                            value={selectedLanguage}
                            onChange={(e) => handleLanguageChange(e.target.value)}
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel
                                value="en"
                                control={<Radio size="small" />}
                                label="English"
                                sx={{
                                    m: 0,
                                    px: 0.5,
                                    borderRadius: 0.5,
                                    '&:hover': { background: '#eef5fb' },
                                    '& .MuiFormControlLabel-label': { color: theme.palette.grey[900], fontSize: '0.9rem' }
                                }}
                            />
                            <FormControlLabel
                                value="gre"
                                control={<Radio size="small" />}
                                label="Ελληνικά"
                                sx={{
                                    m: 0,
                                    px: 0.5,
                                    borderRadius: 0.5,
                                    '&:hover': { background: '#eef5fb' },
                                    '& .MuiFormControlLabel-label': { color: theme.palette.grey[900], fontSize: '0.9rem' }
                                }}
                            />
                        </RadioGroup>
                    </FormControl>
                </Paper>
            </ClickAwayListener>
        </Popper>
    );
};

export default LanguageSelector;
